import { AxiosRequestConfig } from 'axios';
import { useCallback } from 'react';
import { useLoadingBarState } from '../../components/LoadingBar/LoadingBarContext';
import { useToastMessageState } from '../../components/ToastMessage/ToastMessageProvider';
import { ICompanyDataModel } from '../../data-models/company.data-model';
import { LoadingId } from '../../types';
import { createCompany } from '../queries/MaggieCompanyQueries';
import { getErrorMessage } from '../queryHelpers';

import { getForesightStore } from '../../util/jotai-store';
import { companyStateJ } from '../state/CompanyStateJ';
import { prepareCompanyPayload } from './useUpdateCompanyAndState';

export function useCreateCompanyAndUpdateState(
  showInfoToast = true,
  config?: AxiosRequestConfig<Partial<ICompanyDataModel>>
) {
  const { pushErrorToast, pushInfoToast } = useToastMessageState();
  const { actions } = useLoadingBarState();

  return useCallback(
    async (payload: Partial<ICompanyDataModel>) => {
      actions.startLoading(LoadingId.createCompany);
      const store = getForesightStore();

      try {
        const res = await createCompany(prepareCompanyPayload(payload), config);
        const newCompany = res.data;
        store.set(companyStateJ(newCompany.id), newCompany);
        if (showInfoToast) {
          pushInfoToast({ message: 'Successfully created company' });
        }
        return newCompany;
      } catch (err) {
        console.error(err);
        const message = getErrorMessage(err, 'Failed to create company');
        pushErrorToast({ message });
      } finally {
        actions.stopLoading(LoadingId.createCompany);
      }
    },
    [actions, config, pushErrorToast, pushInfoToast, showInfoToast]
  );
}
